import type { JSX } from 'react';
import { useState } from 'react';
import { Editor } from '@/features/editor/Editor';
import { useTheme } from '@/features/editor/hooks';
import { HowItWorks } from './HowItWorks';
import { Logo } from './Logo';
import { Wordmark } from './Wordmark';
import styles from './App.module.css';

type View = 'editor' | 'about';

export function App(): JSX.Element {
  const [view, setView] = useState<View>('editor');
  const [theme, setTheme] = useTheme();

  return (
    <div className={styles.shell}>
      <a className={styles.skip} href="#main">
        Перейти к содержимому
      </a>

      <header className={styles.header}>
        {/* Знак и словоформа — из исходной иллюстрации, а не набор шрифтом:
            у «Курлыка» своё начертание, и подменять его похожим нельзя. */}
        <div className={styles.brand}>
          <Logo className={styles.logo} />
          <div className={styles.brandText}>
            {/* Не заголовок: на странице «Как это работает» свой h1,
                а двух первых заголовков на странице быть не должно. */}
            <p className={styles.name}>
              <Wordmark className={styles.wordmark} />
              <span className="visually-hidden">Курлык</span>
            </p>
            <p className={styles.tagline}>Конструктор QR-кодов</p>
          </div>
        </div>

        <nav className={styles.nav} aria-label="Разделы">
          <button
            type="button"
            className={view === 'editor' ? styles.navActive : styles.navLink}
            aria-current={view === 'editor' ? 'page' : undefined}
            onClick={() => setView('editor')}
          >
            Редактор
          </button>
          <button
            type="button"
            className={view === 'about' ? styles.navActive : styles.navLink}
            aria-current={view === 'about' ? 'page' : undefined}
            onClick={() => setView('about')}
          >
            Как это работает
          </button>
          <button
            type="button"
            className={styles.navLink}
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            aria-pressed={theme === 'dark'}
          >
            {theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
          </button>
        </nav>
      </header>

      <main className={styles.main} id="main">
        {view === 'editor' ? <Editor /> : <HowItWorks />}
      </main>

      <footer className={styles.footer}>
        <p>
          developed with <span aria-label="любовью">❤️</span> by DementevVV
        </p>
      </footer>
    </div>
  );
}
